import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dd21e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget-calendar-month" }
const _hoisted_2 = { class: "widget-calendar-month__title" }
const _hoisted_3 = { class: "widget-calendar-month__weekdays" }
const _hoisted_4 = { class: "widget-calendar-month__content" }
const _hoisted_5 = ["onClick", "onMouseenter"]

import { computed, PropType } from 'vue'
import _ from 'lodash'
import { getActualMonthDaysInMonthPeriod } from '@/utils/overview-calendar'
import {
  formatIntlMonthAndYear,
  formatIntlShortWeekday,
} from '@/utils/formatters'
import { getDate } from 'date-fns'
import isWithinInterval from 'date-fns/isWithinInterval'
import isSameDay from 'date-fns/isSameDay'
import { CompanyHousingDateAvailability } from '@/models/public/service.model'
import { isHousingDateAvailable } from '@/utils/booking-widget'

// TODO: show disabled days and do not allow to select them

export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetMonth',
  props: {
  days: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  selectedPeriod: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  hoveredPeriod: {
    type: Array as PropType<Date[]>,
    default: () => [],
  },
  availabilities: {
    type: Array as PropType<CompanyHousingDateAvailability[]>,
    default: () => [],
  },
},
  emits: ['onClick', 'onMouseEnter'],
  setup(__props, { emit: emits }) {

const props = __props





const actualMonthDays = computed(() =>
  getActualMonthDaysInMonthPeriod(props.days),
)
const weeks = computed(() => _.chunk(props.days, 7))

const isSelectedDay = (day: Date) =>
  isSameDay(day, props.selectedPeriod[0]) ||
  isSameDay(day, props.selectedPeriod[props.selectedPeriod.length - 1])

const isUnavailableDay = (day: Date) =>
  !isHousingDateAvailable(
    day,
    props.availabilities,
    props.selectedPeriod[0],
    props.selectedPeriod.length > 1
      ? props.selectedPeriod[props.selectedPeriod.length - 1]
      : null,
  )

const isWithinPeriod = (day: Date, period: Date[]) =>
  period.length &&
  isWithinInterval(day, {
    start: period[0],
    end: period[period.length - 1],
  })

const handleClick = (day: Date) => {
  if (isUnavailableDay(day)) return

  emits('onClick', day)
}

const handleMouseEnter = (day: Date) => {
  emits('onMouseEnter', day)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(formatIntlMonthAndYear)(_unref(actualMonthDays)[0])), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weeks)[0], (day) => {
        return (_openBlock(), _createElementBlock("div", {
          key: day,
          class: "widget-calendar-month__weekdays__label"
        }, _toDisplayString(_unref(formatIntlShortWeekday)(day)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weeks), (week) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: week }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day) => {
            return (_openBlock(), _createElementBlock("div", {
              key: day,
              class: "widget-calendar-month__content__day",
              onClick: () => handleClick(day),
              onMouseenter: () => handleMouseEnter(day)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["widget-calendar-month__content__day__label", [
              isSelectedDay(day) &&
                'widget-calendar-month__content__day__label--selected',
              !isSelectedDay(day) &&
                !isUnavailableDay(day) &&
                (isWithinPeriod(day, __props.selectedPeriod) ||
                  isWithinPeriod(day, __props.hoveredPeriod)) &&
                'widget-calendar-month__content__day__label--within-period',
              isUnavailableDay(day) &&
                'widget-calendar-month__content__day__label--unavailable',
            ]])
              }, _toDisplayString(_unref(getDate)(day)), 3)
            ], 40, _hoisted_5))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
}
}

})